import classNames from 'classnames';
import styles from './LinkButton.module.scss';
import { UI_LinkButton as LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';

export interface LinkButtonProps {
	title: string;
	url: string;
	target?: string;
}

export const UI_LinkButton = ({ title, url, target }: LinkButtonProps) => (
	<div className={classNames(styles.LinkButton)}>
		<LinkButton url={url} style="primary" target={target} className={styles.LinkButton_link}>
			{title}
		</LinkButton>
	</div>
);
